import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Modal } from '@mui/material'
import { showSnackBar } from '../../components/Snackbar/Snackbar'
import { submitPortalNote, getPortalNotes } from '../../features/portal/portal'
import { LuX } from 'react-icons/lu'

const PortalRequestModal = ({ open, onClose }) => {
  const dispatch = useDispatch()
  const [noteText, setNoteText] = useState('')
  const [notes, setNotes] = useState([])
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (open) {
      dispatch(getPortalNotes()).then((result) => {
        if (result?.payload?.data) {
          setNotes(result.payload.data.notes || [])
        }
      })
    }
  }, [open, dispatch])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!noteText.trim()) {
      showSnackBar('error', 'Please enter a message')
      return
    }
    if (noteText.length > 2000) {
      showSnackBar('error', 'Message must be 2000 characters or less')
      return
    }

    setSubmitting(true)
    try {
      const result = await dispatch(submitPortalNote({ text: noteText.trim() }))
      if (result?.error) {
        showSnackBar('error', result?.payload || 'Failed to submit request')
      } else {
        showSnackBar('success', 'Request submitted successfully')
        setNoteText('')
        const notesResult = await dispatch(getPortalNotes())
        if (notesResult?.payload?.data) {
          setNotes(notesResult.payload.data.notes || [])
        }
      }
    } catch (error) {
      showSnackBar('error', 'An unexpected error occurred')
    }
    setSubmitting(false)
  }

  return (
    <Modal open={open} onClose={onClose}>
      <div className="flex items-center justify-center h-screen">
        <div className="bg-surface rounded-2xl p-6 max-w-[560px] w-full mx-4 max-h-[80vh] overflow-y-auto">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-semibold text-lg text-text-primary">Submit a Request</h3>
            <button onClick={onClose} className="text-text-secondary hover:text-text-primary">
              <LuX size={18} />
            </button>
          </div>

          <p className="text-[13px] text-text-secondary mb-4">
            Send a message to your case management team. We'll review your request and get back to you.
          </p>

          <form onSubmit={handleSubmit}>
            <textarea
              value={noteText}
              onChange={(e) => setNoteText(e.target.value)}
              placeholder="Type your message here..."
              maxLength={2000}
              rows={5}
              className="w-full border border-divider rounded-xl p-4 bg-paper text-sm text-text-primary placeholder:text-text-secondary resize-none focus:outline-none focus:border-primary-main focus:ring-1 focus:ring-primary-main"
            />
            <div className="flex justify-between items-center mt-3">
              <span className="text-[12px] text-text-secondary">{noteText.length}/2000</span>
              <button
                type="submit"
                disabled={submitting || !noteText.trim()}
                className="px-6 py-2 bg-primary-main text-primary-contrast text-sm font-medium rounded-xl hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {submitting ? 'Submitting...' : 'Submit Request'}
              </button>
            </div>
          </form>

          {notes.length > 0 && (
            <div className="mt-6 border-t border-divider pt-4">
              <p className="font-semibold text-md text-text-primary mb-3">Previous Requests</p>
              <div className="divide-y divide-divider">
                {notes.map((note) => (
                  <div key={note._id} className="py-3">
                    <p className="text-sm text-text-primary whitespace-pre-wrap">{note.text}</p>
                    <p className="text-[12px] text-text-secondary mt-2">
                      {new Date(note.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default PortalRequestModal
